/* global AbortController, autocompleteData, fetch, URLSearchParams, setTimeout, clearTimeout, document, window */
(function () {
  'use strict';

  if (typeof autocompleteData === 'undefined') {
    return;
  }

  if (!jQuery('form.searchform:not(.searchform--no-autocomplete)').length) {
    return;
  }

  class SearchAutocomplete {
    constructor(form) {
      this.form = form;
      this.input = form.querySelector('input[name="s"]');
      this.postType =
        form.querySelector('input[name="post_type"]')?.value || '';
      this.resultsContainer = null;
      this.debounceTimer = null;
      this.minChars = 3;
      this.hasResults = false;
      this.isLoading = false;
      /** @type {AbortController|null} */
      this.abortController = null;
      /** Monotonic id so stale fetch responses never paint over newer typing. */
      this.fetchGen = 0;
      this.composing = false;

      this.init();
    }

    init() {
      if (this.form.querySelector('.autocomplete-results')) return;

      this.resultsContainer = document.createElement('div');
      this.resultsContainer.className = 'autocomplete-results';
      this.form.style.position = 'relative';
      this.form.appendChild(this.resultsContainer);

      this.input.addEventListener('input', () => this.handleInput());
      this.input.addEventListener('compositionstart', () => {
        this.composing = true;
      });
      this.input.addEventListener('compositionend', () => {
        this.composing = false;
        this.handleInput();
      });
      this.input.addEventListener('focus', () => this.handleFocus());
      document.addEventListener('click', (e) => this.handleClickOutside(e));
      this.input.addEventListener('keydown', (e) => this.handleKeydown(e));
    }

    handleFocus() {
      // Only show existing results on focus, don't refetch
      if (this.hasResults && this.input.value.trim().length >= this.minChars) {
        this.showResults();
      }
    }

    handleInput() {
      if (this.composing) {
        return;
      }

      clearTimeout(this.debounceTimer);

      this.debounceTimer = setTimeout(() => {
        // Strip angle brackets before this ever reaches admin-ajax.php
        const value = this.input.value.trim().replace(/[<>]/g, '');

        if (value.length < this.minChars) {
          this.hideResults();
          this.hasResults = false;
          return;
        }

        this.fetchResults(value);
      }, 300);
    }

    showLoader() {
      this.isLoading = true;
      this.resultsContainer.innerHTML = '';
      const row = document.createElement('div');
      row.className = 'autocomplete-item autocomplete-loader';
      row.textContent =
        (autocompleteData.strings && autocompleteData.strings.loading) ||
        'Loading…';
      this.resultsContainer.appendChild(row);
      this.showResults();
    }

    hideLoader() {
      this.isLoading = false;
    }

    async fetchResults(term) {
      const supportsAbort = typeof AbortController !== 'undefined';
      if (supportsAbort) {
        if (this.abortController) {
          this.abortController.abort();
        }
        this.abortController = new AbortController();
      } else {
        this.abortController = null;
      }
      const myGen = ++this.fetchGen;

      const params = new URLSearchParams({
        action: 'custom_search_filter',
        nonce: autocompleteData.nonce,
        s: term,
        post_type: this.postType,
        autocomplete: '1',
      });

      const url = `${autocompleteData.ajaxUrl}?${params}`;

      this.showLoader();

      try {
        const fetchInit = {};
        if (supportsAbort && this.abortController) {
          fetchInit.signal = this.abortController.signal;
        }
        const response = await fetch(url, fetchInit);
        const data = await response.json();

        this.hideLoader();

        if (myGen !== this.fetchGen) {
          return;
        }

        if (data.success) {
          this.renderResults(data.data.results);
        }
      } catch (error) {
        if (error && error.name === 'AbortError') {
          return;
        }
        this.hideLoader();
        if (myGen !== this.fetchGen) {
          return;
        }
        this.resultsContainer.innerHTML = '';
        const row = document.createElement('div');
        row.className = 'autocomplete-item no-results';
        row.textContent =
          (autocompleteData.strings && autocompleteData.strings.error) ||
          'Error loading results';
        this.resultsContainer.appendChild(row);
      }
    }

    renderResults(results) {
      if (!results.length) {
        this.resultsContainer.innerHTML = '';
        const row = document.createElement('div');
        row.className = 'autocomplete-item no-results';
        row.textContent =
          (autocompleteData.strings && autocompleteData.strings.none) ||
          'No results found';
        this.resultsContainer.appendChild(row);
        this.hasResults = false;
        this.showResults();
        return;
      }

      const html = results
        .map(
          (item, index) => `
            <a href="${item.url}" class="autocomplete-item" data-index="${index}"${
              item.post_type === 'hospital'
                ? ' target="_blank" rel="noopener noreferrer"'
                : ''
            }>
              <span class="autocomplete-title">${this.highlightMatch(item.title)}</span>
              <span class="autocomplete-type">${this.formatPostType(item.post_type)}</span>
            </a>
          `
        )
        .join('');

      this.resultsContainer.innerHTML = html;
      this.hasResults = true;
      this.showResults();
    }

    highlightMatch(title) {
      const term = this.input.value.trim();
      const regex = new RegExp(
        `(${term.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')})`,
        'gi'
      );
      return title.replace(regex, '<strong>$1</strong>');
    }

    formatPostType(type) {
      const labels = autocompleteData.postTypeLabels || {};
      return labels[type] || type;
    }

    handleKeydown(e) {
      const items = this.resultsContainer.querySelectorAll(
        '.autocomplete-item:not(.no-results):not(.autocomplete-loader)'
      );
      const current = this.resultsContainer.querySelector(
        '.autocomplete-item.active'
      );
      let index = current ? parseInt(current.dataset.index, 10) : -1;

      switch (e.key) {
        case 'ArrowDown':
          e.preventDefault();
          index = Math.min(index + 1, items.length - 1);
          this.setActiveItem(items, index);
          break;
        case 'ArrowUp':
          e.preventDefault();
          index = Math.max(index - 1, 0);
          this.setActiveItem(items, index);
          break;
        case 'Enter':
          if (current) {
            e.preventDefault();
            if (current.target === '_blank') {
              window.open(current.href, '_blank', 'noopener');
            } else {
              window.location.href = current.href;
            }
          }
          break;
        case 'Escape':
          this.hideResults();
          break;
      }
    }

    setActiveItem(items, index) {
      items.forEach((item) => item.classList.remove('active'));
      if (items[index]) items[index].classList.add('active');
    }

    handleClickOutside(e) {
      if (!this.form.contains(e.target)) this.hideResults();
    }

    showResults() {
      this.resultsContainer.classList.add('visible');
    }
    hideResults() {
      this.resultsContainer.classList.remove('visible');
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    document
      .querySelectorAll('form.searchform:not(.searchform--no-autocomplete)')
      .forEach((form) => {
      if (form.dataset.autocompleteInit) return;
      form.dataset.autocompleteInit = 'true';
      new SearchAutocomplete(form);
    });
  });
})();
